import { ApiResponse } from "../../../types";
import { deleteRequestWithAuth, getRequest, getRequestWithAuth, getRequestWithParamsAndQuery, getRequestWithQuery, patchRequestWithAuth, postRequest, postRequestWithAuth } from "../configuration";
import getApiWithVersion from "../apis";
import { API_VERSION } from "../../constants/common";
import { Address, AddressAdded, AddressPayload, GeoCoordsResponse, PincodeData } from "../../../types/address.type";
const api = getApiWithVersion(API_VERSION.V1);


export interface API_Address {
    getPincodeServiciability(pincode:string,check_service:any): Promise<ApiResponse<PincodeData>>
    getAllAddress(): Promise<ApiResponse<Address[]>>
    postAddress(addressPayload:AddressPayload):Promise<ApiResponse<AddressAdded>>;
    getCoordinates(query:any):Promise<ApiResponse<GeoCoordsResponse>>; // need to correcct type from any to actual
    patchAddress(addressPayload:any,address_id:string|number):Promise<ApiResponse<AddressAdded>>;// need to correcct type from any to actual
    postLocationLog(locationDetails:any,query:any):Promise<ApiResponse<true>>;// need to correcct type from any to actual
    // fetchAddresses(user_id: number): Promise<ApiResponse<Address[]>>; 

    // getCoordsFromAddress(address: string): Promise<ApiResponse<GeoCoordsResponse>>;
    deleteAddress(address_id: string | number): Promise<ApiResponse<boolean>>;



}

const address: API_Address = {
     getPincodeServiciability(pincode,check_service) {
       const q = {check_service}
    return getRequestWithParamsAndQuery(api.PINCODE, pincode,q)
  },
  getAllAddress() {
    return getRequestWithAuth(api.ADDRESS_LiST)
  },
  postAddress(addressPayload) {
    return postRequestWithAuth(api.ADDRESS_ADD,addressPayload)
  },
  getCoordinates(query){
    const q = {query}
return getRequestWithQuery(api.GEO_COORDS,q)
  },

  //   getCoordsFromAddress(address) {
  //   return getRequestWithQuery(api.GET_COORDS, {
  //     query: { address }
  //   });
  // },

  patchAddress(addressPayload,address_id){
return patchRequestWithAuth(api.ADDRESS_UPDATE,addressPayload,address_id)
  },

  postLocationLog(locationDetails,query){
    const q = query
   return postRequest(api.LOCATION_LOG,locationDetails,undefined,q)
  },

  // fetchAddresses(user_id) {
  //       return getRequestWithAuth(api.ADDRESS, user_id);
  //   },

 deleteAddress(address_id) {
  return deleteRequestWithAuth(api.ADDRESS, address_id);
}

}

export default address

